// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.NlqConfiguration.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import React, { Component } from 'react';
import connect from 'share/enhancers/Izenda.Connect';
import { observer } from 'mobx-react';
import action from './Izenda.NLQSettingsAction';

import GridLayout from 'share/components/controls/Izenda.GridLayout';
import Button from 'share/components/controls/Izenda.Button';
import Alert from 'share/components/controls/Izenda.Alert';
import Prediction from '../MachineLearning/Izenda.Prediction';
import NLQSettings from './Izenda.NLQSettings';
import LicenseCheckerConstants from "logic/data/Izenda.LicenseCheckerConstants";
// const ConfigurationHeader = observer(function ConfigurationHeader(props: any) {
//   return (
//     <GridLayout className="u-bgWhite u_paddingAll">
//       <GridLayout.Row>
//         <GridLayout.Col cols={3}>
//         </GridLayout.Col>
//         <GridLayout.Col cols={3}>
//         </GridLayout.Col>
//       </GridLayout.Row>
//     </GridLayout>
//   );
// });

const ActionHeader = observer(function ActionHeader(props) {
  const {
    alertDetails,
    canSaveNLQSettings,
    localization
  } = props;
  return (
    <div className="izenda-Wrapper-header">
      <div className="izenda-Alert-container">
        <Alert type={alertDetails.alertType} onAutoHide={props.onAutoHide}>
          {alertDetails.message}
        </Alert>
      </div>
      <div className="pull-right">
        <Button
          onClick={props.onSave}
          label={localization.getText('COMMON_LABEL_SAVE')}
          className="btn btn-default u_marginRight"
          disabled={!canSaveNLQSettings}
        />
        <Button onClick={props.onCancel} label={localization.getText('COMMON_LABEL_CANCEL')} />
      </div>
    </div>
  );
});

@connect(action)
export default class NlqConfiguration extends Component {
  componentDidMount() {
    const { store, loader } = this.props;

    loader.startLoading();
    store.init();
    this.props.store.getpredictionServerDetails().finally(loader.endLoading.bind(loader));
    this.props.store.getMLDBsettings();
    this.props.store.model.changeDBConnectionShow(false);
  }

  componentWillUnmount() {
     this.props.resetAlert();
  }

  testServerConfiguration(ipAdd){
    const { store ,loader} = this.props;
    const { model } = store;
    loader.startLoading();
    this.props.store.checkPredictionServerStatus(ipAdd).then((data)=>{
    this.props.store.model.predictionServerStatus = JSON.parse(data);
    let result =  JSON.parse(data);
    if(result.success){
      this.props.store.model.dbConectionActive = false;
      this.props.store.model.predictionServerSuccess = true;
    }
    this.props.store.alertDetails.set({
      success: result.success,
      message: result.messages[0]
    });
   }).catch((error)=>{
    this.props.store.alertDetails.set({
      message: "Error while connecting to the Machine Learning Api"
    });
   })
   .finally(loader.endLoading.bind(loader));

  };

  testDBConfiguration(connectionString,ipAdd){
    const {store,loader} = this.props;
    const { model } = store;
    loader.startLoading();
    this.props.store.checkMLDBStatus(connectionString,ipAdd).then((data)=>{
     this.props.store.model.mlDBConnectionStatus = JSON.parse(data);
     let result =  JSON.parse(data);
      this.props.store.alertDetails.set({
        success: result.success,
        message: result.messages[0]
      });
      if(result.success){
        this.props.store.model.dbServerSuccess = false;
      }
    }).catch((error)=>{
      this.props.store.alertDetails.set({
        message: "Error while connecting to the Database"
      });
      console.log(error);
    })
    .finally(loader.endLoading.bind(loader));
  }

  render() {
    const props = this.props;
    const { store, localization,authorization } = props;
    const { alertDetails } = store;
    return (
      <div className="u_paddingAll">
        <ActionHeader
          onSave={props.saveConfig}
          onCancel={props.cancelChangeConfig}
          onAutoHide={props.resetAlert}
          localization={localization}
          alertDetails={alertDetails}
          canSaveNLQSettings={store.canSaveNLQSettings && (authorization.checkLicense(LicenseCheckerConstants.LICENSE_KEY.Nlq))}
        />
        <div className="izenda-Wrapper-content u_paddingAll">
            <div>
              <Prediction
              store={this.props.store}
              onclickmlserver={ () => this.testServerConfiguration(store.model.mlServerIp)}
              // onclickdbconnection={() => this.testDBConfiguration(store.model.dbConnectionStringInput,store.model.mlServerIp)}
              />
             {
              (authorization.checkLicense(LicenseCheckerConstants.LICENSE_KEY.Nlq)) ?
                <NLQSettings
                {...this.props}
                store={this.props.store}/> :  null
            }
            </div>
            <div>

            </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./ui/modules/Settings/SystemConfiguration/NlqConfiguration/Izenda.NlqConfiguration.js